import React, { useEffect, useRef, useState } from 'react';
import './Advertisements.css';
import { useThemeContext } from '../../../Context/ThemeContext';
import { useTranslation } from 'react-i18next';
import { Box, Button, Card, CardActions, CardContent, Grid, IconButton, MenuItem, Select, Typography } from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from '../../../Utils/constants';
import { getAdvertisements, getLiveAdvertisements, getMachineLocations } from '../../../Services/authService';
import { useNavigate } from 'react-router-dom';
import AdvertisementCard from './AdvertisementCard';
import SectionLoader from '../../../Components/Common/SectionLoader';

function Advertisements() {
  const navigate = useNavigate()
  const { mode } = useThemeContext();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(true);
  const [advertisements, setAdvertisements] = useState([]);
  const [advertisementsLive, setAdvertisementsLive] = useState([]);
  const [locations, setLocations] = useState([]);

  const backgroundCard = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const btnAddColor = mode === 'dark' ? DARKCOLORS.Secondary500 : LIGHTCOLORS.Secondary500;
  const textColor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
  const btnborderColor = mode === 'dark' ? DARKCOLORS.GreyScale50 : LIGHTCOLORS.GreyScale50;

  const fetchLiveAdvertisements = async () => {
    setLoading(true);
    try {
      const advertismenets = await getLiveAdvertisements();
      setAdvertisementsLive(advertismenets);
    } catch (error) {
      console.error(t("advertisement.errorFetchingData"), error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAdvertisements = async () => {
    setLoading1(true);
    try {
      const advertismenets = await getAdvertisements();
      setAdvertisements(advertismenets);
    } catch (error) {
      console.error(t("advertisement.errorFetchingData"), error);
    } finally {
      setLoading1(false);
    }
  };

  const fetchLocations = async () => {
    try {
      const data = await getMachineLocations();
      setLocations(data);
    } catch (error) {
      console.error(t("advertisement.errorFetchingLocations"), error);
    }
  };

  const advertisementList = Array.isArray(advertisements)
  ? advertisements
  : Array.isArray(advertisements?.data)
    ? advertisements.data
    : [];

const liveAdvertisementList = Array.isArray(advertisementsLive)
  ? advertisementsLive
  : Array.isArray(advertisementsLive?.data)
    ? advertisementsLive.data
    : [];

  useEffect(() => {
    fetchAdvertisements();
    fetchLiveAdvertisements();
    fetchLocations();
  }, []);

  return (
    <div className='dashboard-container-overview'>
      {/* Heading & btn */}
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <h2 className='membership-text-heading membership-text-headings' style={{ margin: "0px" }}>{t('advertisement.advertisements')}</h2>

        <Box>
          {/* Advertisement btn */}
          <IconButton className='add-machine add-machines1' onClick={() => navigate(ROUTES.ADD_ADVERTISEMENT, { state: { mode: "add" } })} sx={{
            borderRadius: '40px', padding: '11px 20px', backgroundColor: btnAddColor, color: "#000", mx: '7px',
            "&:hover": {
              backgroundColor: btnAddColor,
              color: "#000",
              boxShadow: "none",
            },
          }} >
            {t('advertisement.newAdvertisement')} <AddCircleOutline fontSize='small' sx={{ marginLeft: '10px' }} />
          </IconButton>
        </Box>
      </Box>

      <Box sx={{ background: backgroundCard, p: 3, margin: "20px 0px", borderRadius: "12px" }}>
        <Box>
          <h2 className='franchise-heading-text franchise-heading-texts' style={{ margin: "0px" }}>{t('advertisement.liveAdvertisements')}</h2>
          {/* Grid Layout for Advertisements */}
          <Grid
            container
            spacing={2}
            sx={{ margin: "1rem 0rem" }}
          >
            {loading ? (
              <Grid item xs={12}>
                <SectionLoader />
              </Grid>
            ) : liveAdvertisementList.length === 0 ? (
              <Grid item xs={12}>
                <Typography sx={{ color: textColor, p: 2 }}>
                  {t('advertisement.no_Ads')}
                </Typography>
              </Grid>
            ) : (
            liveAdvertisementList.map((advertisement, index) => (
                <Grid
                  item
                  key={index}
                  xs={12}      // 1 per row on mobile
                  sm={6}       // 2 per row on tablet
                  md={4}
                >
                  <AdvertisementCard advertisement={advertisement} locations={locations} />
                </Grid>
              ))
            )}
          </Grid>
        </Box>
        <Box>
          <h2 className='franchise-heading-text franchise-heading-texts' style={{ margin: "3rem 0rem 0rem" }}>{t('advertisement.savedAdvertisements')}</h2>
          {/* Grid Layout for Advertisements */}
          <Grid
            container
            spacing={2}
            sx={{ margin: "1rem 0rem" }}
          >
            {loading1 ? (
              <Grid item xs={12}>
                <SectionLoader />
              </Grid>
            ) : advertisementList.length === 0 ? (
              <Grid item xs={12}>
                <Typography sx={{ color: textColor, p: 2 }}>
                 {t('advertisement.no_Ads')}
                </Typography>
              </Grid>
            ) : (
            advertisementList.map((advertisement, index) => (
                <Grid
                  item
                  key={index}
                  xs={12}   // 1 per row on mobile
                  sm={6}    // 2 per row on tablet
                  md={4}    // 3 per row on desktop
                  sx={{ boxSizing: "border-box" }}
                >
                  <AdvertisementCard advertisement={advertisement} locations={locations} />
                </Grid>
              ))
            )}
          </Grid>
        </Box>
      </Box>
    </div>
  );
}

export default Advertisements;
